var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.552 6l4.334-4.333a.39.39 0 10-.553-.553L6 5.448 1.667 1.114a.39.39 0 00-.553.553L5.447 6l-4.333 4.333a.39.39 0 00.553.553L6 6.553l4.333 4.333a.389.389 0 00.553 0 .39.39 0 000-.553L6.552 6z",
    stroke: "#000",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.21eca65d53095479d127c61cb36ffdb1.svg";
export { ForwardRef as ReactComponent };